import { StateContainer } from './StateContainer';

export default StateContainer;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/StateContainer/index.ts